import {
  FETCH_FLEETADMIN_EARNING,
  FETCH_FLEETADMIN_EARNING_SUCCESS,
  FETCH_FLEETADMIN_EARNING_FAILED,
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { get, onValue } from "firebase/database";

const getFleetAdminDisplayName = (user) => {
  if (!user) return "Logistics Company";
  const personName = [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
  return (
    user.companyName ||
    user.company_name ||
    user.businessName ||
    user.business_name ||
    user.fleetAdminName ||
    personName ||
    user.email ||
    "Logistics Company"
  );
};

const parseAmount = (value) => {
  const amount = parseFloat(value);
  return isNaN(amount) ? 0 : amount;
};

const firstPresent = (...values) => values.find((value) => value !== undefined && value !== null && value !== "");

const getFleetGrossAmount = (booking) => {
  if (booking && booking.acceptedOfferType === "fleet") {
    const offer = booking.acceptedFleetOffer || {};
    return parseAmount(firstPresent(booking.fleetAdminEarningGrossAmount, offer.amount, offer.bidAmount));
  }
  return parseAmount(firstPresent(booking && booking.trip_cost, booking && booking.fleetCommission));
};

const getFleetCommissionAmount = (booking) => {
  if (booking && booking.acceptedOfferType === "fleet") {
    return parseAmount(firstPresent(booking.fleetAdminEarningCommissionAmount, booking.garahexCommissionAmount));
  }
  return 0;
};

const getFleetNetAmount = (booking) => {
  if (booking && booking.acceptedOfferType === "fleet") {
    const grossAmount = getFleetGrossAmount(booking);
    const commissionAmount = getFleetCommissionAmount(booking);
    return parseAmount(firstPresent(booking.fleetAdminEarningNetAmount, booking.fleetAdminEarningAmount, Math.max(grossAmount - commissionAmount, 0)));
  }
  return parseAmount(booking && booking.fleetCommission);
};

export const fetchFleetAdminEarnings = () => async (dispatch) => {

  const {
    bookingListRef,
    settingsRef
  } = firebase;

  dispatch({
    type: FETCH_FLEETADMIN_EARNING,
    payload: null
  });

  const userInfo = store.getState().auth.profile;
  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();
  const decimals = settings.decimal || 2;

  onValue(bookingListRef(userInfo.uid, userInfo.usertype), snapshot => {
    if (snapshot.val()) {
      const mainArr = snapshot.val();
      const arr = Object.keys(mainArr).map((j) => {
        const booking = mainArr[j];
        const grossAmount = getFleetGrossAmount(mainArr[j]);
        const commissionAmount = getFleetCommissionAmount(mainArr[j]);
        const netAmount = getFleetNetAmount(mainArr[j]);
        if ((booking.status === 'PAID' || booking.status === 'COMPLETE' || booking.status === 'COMPLETED') && booking.fleetadmin && netAmount > 0) {
          const offer = booking.acceptedFleetOffer || {};
          return {
            id: j,
            bookingReference: booking.reference || booking.bookingNumber || j,
            bookingDate: booking.bookingDate || booking.tripdate || booking.tripDate || "",
            customerName: booking.customer_name || "",
            vehicleType: typeof booking.carType === "string" ? booking.carType : (booking.carType && booking.carType.name ? booking.carType.name : ""),
            fleetUId: booking.fleetadmin,
            fleetadminName: booking.fleetadminName || getFleetAdminDisplayName(offer || booking),
            grossAmount: grossAmount.toFixed(decimals),
            garahexCommissionAmount: commissionAmount.toFixed(decimals),
            netAmount: netAmount.toFixed(decimals),
            fleetCommission: netAmount.toFixed(decimals),
            commissionType: booking.commission_type || booking.commissionType || booking.convenience_fee_type || "",
            paymentMode: booking.payment_mode || "",
            bookingStatus: booking.status || "",
            withdrawalStatus: booking.withdrawalStatus || booking.fleetAdminWithdrawalStatus || "Not requested",
            source: booking.acceptedOfferType === "fleet" ? "acceptedFleetOffer" : "legacyFleetCommission"
          };
        }
        return null;
      }).filter(Boolean);
      dispatch({
        type: FETCH_FLEETADMIN_EARNING_SUCCESS,
        payload: arr
      });

    } else {
      dispatch({
        type: FETCH_FLEETADMIN_EARNING_FAILED,
        payload: "No data available."
      });
    }
  });
};
